// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel {
    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap;
    }
}
SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.discriminator = undefined;
SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.additionalProperties = false;
SharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel"
    },
];
//# sourceMappingURL=sharedUpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.js.map